import { render, staticRenderFns } from "./DoubleChecks.vue?vue&type=template&id=d47ed2e4&scoped=true"
import script from "./DoubleChecks.vue?vue&type=script&lang=js"
export * from "./DoubleChecks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d47ed2e4",
  null
  
)

export default component.exports